import styles from './CheckPolloverse.module.scss';

import { Button } from '@/components/Button';
import { openTelegramLink } from '@/utils';
import { motion, useIsomorphicLayoutEffect } from 'framer-motion';

import ArrowRight from '@/modules/tasks/images/arrow-right.svg?react';
import CloseIcon from '@/shared/icons/closeIcon.svg?react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type CheckPolloverseProps = { setIsOpen: (isOpen: boolean) => void };

export const CheckPolloverse = ({ setIsOpen }: CheckPolloverseProps) => {
  const [isShown, setIsShown] = useState(false);
  const { t } = useTranslation();

  const onClick = () => {
    openTelegramLink('https://t.me/polloverse', true);
    setIsOpen(false);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  useIsomorphicLayoutEffect(() => {
    setTimeout(setIsShown, 500, true);

    const app = document.getElementById('app');

    if (!app) return;

    app.style.overflow = 'hidden';

    return () => {
      app.style.overflow = '';
    };
  }, []);

  return (
    <div className={styles.blurWrapper}>
      <motion.div
        className={styles.wrapper}
        initial={{ y: '100%' }}
        animate={isShown ? { y: 0 } : { y: '100%' }}
      >
        <CloseIcon className={styles.close} onClick={onClose} />
        <h2 className={styles.title}>
          {t('Join')}&nbsp;<span className={styles.accent}>@polloverse</span>
        </h2>
        <p className={styles.subtitle}>
          {t('Stay in channel to claim daily rewards')}
        </p>
        <Button gradient onClick={onClick}>
          {t('Go to polloverse')}&nbsp;
          <ArrowRight />
        </Button>
      </motion.div>
    </div>
  );
};
